import { CircularProgress } from "@faro-lotv/flat-ui";
import { Backdrop, SxProps, Theme } from "@mui/material";
import type { JSX } from "react";

export type ModalSpinnerProps = {
  /** The style of the backdrop */
  sx?: SxProps<Theme>;
  /** The flag used to show/hide the backdrop */
  open: boolean;
};

/**
 * @returns A modal spinner for loading screen
 */
export function ModalSpinner({ sx, open }: ModalSpinnerProps): JSX.Element {
  return (
    <Backdrop sx={sx} open={open}>
      <CircularProgress aria-label="modal spinner" />
    </Backdrop>
  );
}
